const appMessage = {
  createAppSuccess: 'App successfully created',
  updateAppSuccess: 'App successfully updated',
  deleteAppSuccess: 'App successfully deleted',
  appListError: 'Error retrieving app list'
}

export default appMessage;